import { useMutation } from '@tanstack/react-query';
import { useTagsContext } from './useTagsContext';
import { Tag } from 'tags/models/tags';
import { tagsMutationKeys } from 'src/tags/utils/queries';

type AssignTagsMutationProps = {
  createdTagIds: string[];
  tagsToAssign: Tag[];
};

export const useTagsAssign = (id: string, onSuccess: (tag: Tag[]) => void) => {
  const { assignTags, createTag, fetchAssignedTags } = useTagsContext();
  return useMutation({
    mutationKey: tagsMutationKeys.assignTags,
    mutationFn: async ({ createdTagIds, tagsToAssign }: AssignTagsMutationProps) => {
      if (!tagsToAssign) {
        return;
      }

      if (tagsToAssign?.length === 0) {
        return assignTags(id, []);
      }

      const tagIdsToAssign = [];
      for (const tag of tagsToAssign) {
        if (createdTagIds.includes(tag.id)) {
          const newTag = await createTag(tag.name);
          tagIdsToAssign.push(newTag.id);
        } else {
          tagIdsToAssign.push(tag.id);
        }
      }

      return assignTags(id, tagIdsToAssign);
    },
    onSuccess: async () => {
      const tags = await fetchAssignedTags(id);
      if (onSuccess) {
        onSuccess(tags);
      }
    },
  });
};
